<template>
  <b-row>
    <b-card class="w-100 h-100">
      <ValidationObserver ref="form">
        <b-row v-if="departmentData !== undefined">
          <b-col cols="12" class="mt-1 mb-1">
            <b-form-group>
              <label for="name"
                >ชื่อหน่วยงานภาษาไทย <span class="text-danger">*</span></label
              >
              <ValidationProvider
                rules="required"
                name="ชื่อหน่วยงานภาษาไทย"
                v-slot="{ errors }"
              >
                <b-form-input
                  id="name"
                  v-model="departmentData.name"
                  placeholder="กรุณากรอก ชื่อหน่วยงานภาษาไทย"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-form-group>
          </b-col>

          <b-col v-if="departmentData.deptType == 1" cols="6" class="mt-1 mb-1">
            <b-form-group>
              <label for="nameAbbr"
                >ชื่อย่อหน่วยงานภาษาไทย </label
              >
              <b-form-input
                  id="nameAbbr"
                  v-model="departmentData.nameAbbr"
                  placeholder="กรุณากรอก ชื่อย่อหน่วยงานภาษาไทย"
                />
            </b-form-group>
          </b-col>

          <b-col cols="12" class="mt-1 mb-1">
            <b-form-group>
              <label for="nameEn"
                >ชื่อหน่วยงานภาษาอังกฤษ
                <span class="text-danger">*</span></label
              >
              <ValidationProvider
                rules="required"
                name="ชื่อหน่วยงานภาษาอังกฤษ"
                v-slot="{ errors }"
              >
                <b-form-input
                  id="nameEn"
                  v-model="departmentData.nameEn"
                  placeholder="กรุณากรอก ชื่อหน่วยงานภาษาอังกฤษ"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-form-group>
          </b-col>

          <b-col v-if="departmentData.deptType == 1" cols="6" class="mt-1 mb-1">
            <b-form-group>
              <label for="nameEnAbbr"
                >ชื่อย่อหน่วยงานภาษาอังกฤษ </label
              >
              <b-form-input
                  id="nameEnAbbr"
                  v-model="departmentData.nameEnAbbr"
                  placeholder="กรุณากรอก ชื่อย่อหน่วยงานภาษาอังกฤษ"
                />
            </b-form-group>
          </b-col>

          <!-- <AddressForm
            :addressData="departmentData.addressModel"
            @handleSetAddress="setAddress"
          >
          </AddressForm> -->
          <span v-if="departmentData.addressModel !== null">
              <AddressForm
                :addressData="departmentData.addressModel"
                @handleSetAddress="setAddress"
                >
              </AddressForm>
          </span>

          <b-col cols="12" md="6" class="mt-1 mb-1">
            <b-form-group>
              <label for="createDate">อีเมลหน่วยงาน</label>
              <ValidationProvider name="อีเมลหน่วยงาน" v-slot="{ errors }">
                <b-form-input
                  id="contactEmail"
                  v-model="departmentData.contactEmail"
                  placeholder="กรุณากรอก อีเมลหน่วยงาน"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" class="mt-1 mb-1">
            <b-form-group>
              <label for="createDate">เบอร์โทรศัพท์หน่วยงาน </label>
              <ValidationProvider
                name="เบอร์โทรศัพท์หน่วยงาน"
                v-slot="{ errors }"
              >
                <b-form-input
                  id="contactEmail"
                  v-model="departmentData.contactNumber"
                  placeholder="กรุณากรอก เบอร์โทรศัพท์หน่วยงาน"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" class="mt-1 mb-1">
            <b-form-group>
              <label for="createDate">แฟกซ์หน่วยงาน </label>
              <ValidationProvider
                name="เบอร์โทรศัพท์หน่วยงาน"
                v-slot="{ errors }"
              >
                <b-form-input
                  id="contactFax"
                  v-model="departmentData.contactFax"
                  placeholder="กรุณากรอก แฟกซ์หน่วยงาน"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-form-group>
          </b-col>

          <b-col cols="12" class="mt-1 mb-1">
            <b-form-group>
              <label for="createDate"
                >ชื่อผู้ติดต่อ (ใช้ในหัวข้อเอกสารส่งต่อ)
              </label>
              <ValidationProvider name="ชื่อผู้ติดต่อ" v-slot="{ errors }">
                <b-form-input
                  id="contactName"
                  v-model="departmentData.contactName"
                  placeholder="กรุณากรอก ชื่อผู้ติดต่อ"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" class="">
            <b-form-group label="สถานะการใช้งาน">
              <b-form-radio-group
                id="isActive"
                v-model="departmentData.isActive"
                :options="activeOptions"
                name="radio-is-active"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" class="">
            <b-form-group label="สถานะการเชื่อมต่อ Service">
              <b-form-radio-group
                id="isService"
                v-model="departmentData.isService"
                :options="serviceOptions"
                name="radio-is-service"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" class="">
            <b-form-group label="ให้ประชาชนเห็นความคิดเห็น (ปกติ ประชาชนจะเห็นเฉพาะสถานะขอเอกสารเพิ่มเติมเท่านั้น ถ้าเลือกใช่ หมายความว่าประชาชนจะเห็นความเห็นทุกอย่างที่หน่วยงานนี้ทำงาน)">
              <b-form-radio-group
                id="isCommentPublic"
                v-model="departmentData.isCommentPublic"
                :options="serviceOptions"
                name="is-comment-public-service"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>

          <b-col v-if="departmentData.deptType === 2 || departmentData.isInternal === true" cols="12" md="6" class="">
            <b-form-group label="สถานะการส่งต่อหน่วยงานภายใน">
              <b-form-radio-group
                id="isShowInSelect"
                v-model="departmentData.isShowInSelect"
                :options="internalConnectOptions"
                name="radio-is-showinselect"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>

          <b-col cols="12" class="d-flex justify-content-between">
            <b-button variant="secondary" @click="onCancelBtnClicked">
              ยกเลิก
            </b-button>
            <b-button variant="primary" @click="onSubmitBtnClicked">
              บันทึกข้อมูล
            </b-button>
          </b-col>
        </b-row>
      </ValidationObserver>
    </b-card>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BFormInput,
  BFormGroup,
  BFormRadioGroup,
  BFormDatepicker,
  BFormTimepicker,
  BFormFile,
} from "bootstrap-vue";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";

import AddressForm from "@/views/Complaint/components/AddressForm.vue";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
    };
  },
  message: "กรุณากรอก{_field_}",
  computesRequired: true,
});

export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BFormInput,
    BFormGroup,
    BFormRadioGroup,
    BFormDatepicker,
    BFormTimepicker,
    BFormFile,
    ValidationObserver,
    ValidationProvider,
    extend,
    AddressForm,
  },
  data() {
    return {
      activeOptions: [
        { text: "ใช้งาน", value: true },
        { text: "ไม่ใช้งาน", value: false },
      ],
      internalConnectOptions: [
        { text: "สามารถส่งต่อได้", value: true },
        { text: "ไม่สามารถส่งต่อได้", value: false },
      ],
      serviceOptions: [
        { text: "เชื่อมต่อ Service แล้ว", value: true },
        { text: "ไม่ได้เชื่อมต่อ Service", value: false },
      ],
      serviceOptions: [
        { text: "ใช่", value: true },
        { text: "ไม่ใช่", value: false },
      ],
    };
  },
  created() {},
  props: {
    departmentData: { isActive: true },
  },
  methods: {
    onCancelBtnClicked() {
      this.$emit("handleCancel");
    },
    onSubmitBtnClicked() {
      const _this = this;
      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }
        this.$swal({
          title: "ยืนยันการบันทึกข้อมูล?",
          text: "",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "บันทึก",
          cancelButtonText: "ยกเลิก",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-primary ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            _this.$emit("handleSubmit");
          }
        });
      });
    },
    setAddress(address) {
      this.$emit("handleSetAddress", address);
    },
  },
};
</script>

<style></style>
